import { CustomizedTypography } from '@components/Customized';
import { makeStyles } from '@material-ui/core';

interface ProgressInfoDateWithButtonProps {
  title: string;
  date: string;
  button?: React.ReactNode;
}

const ProgressInfoDateWithButton = ({
  title,
  date,
  button
}: ProgressInfoDateWithButtonProps) => {
  const { ProgressInfoDateWithButtonContainer } = useStyles();

  return (
    <div className={ProgressInfoDateWithButtonContainer}>
      <div className="item">
        <CustomizedTypography variant="subtitle2" color="textSecondary">
          {title}
        </CustomizedTypography>
        <CustomizedTypography variant="body2">{date}</CustomizedTypography>
      </div>

      {button}
    </div>
  );
};

export default ProgressInfoDateWithButton;

const useStyles = makeStyles({
  ProgressInfoDateWithButtonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});
